import { Component, Input } from '@angular/core';
import { ImagingRequest } from '../models/imaging-requests.model';

@Component({
    selector: 'app-imaging-requests-column',
    templateUrl: './imaging-requests-column.component.html',
    styleUrls: ['./imaging-requests-column.component.scss']
})
export class ImagingRequestsColumnComponent {
    @Input()
    imagingRequests: ImagingRequest[];
    @Input()
    userCanEditimagingRequests: boolean = false;
}
